import { useMemo } from "react";

import getFloor from "../../services/getters/floor_getters/get_floor";
import loadFloor from "../../actions/react_query/floors/load_floor";
import useQueryWithState from "../use_query_with_state";
import { doAllExist } from "../../services/utilities/general";

import type Floor from "../../models/domain/floor";
import type { StandardQueryOptions } from "type_aliases";

const useFloor = (projectId: string, floorId: string, options?: Omit<StandardQueryOptions<Promise<Floor>, any, Floor>, "enabled">) => {
  const props = useMemo(() => ({ projectId, floorId }), [floorId, projectId]);
  return useQueryWithState(
    ["useFloor", [projectId, floorId]],
    loadFloor,
    getFloor,
    { ...options, enabled: doAllExist(projectId, floorId) },
    props,
    projectId,
    floorId
  );
};

export default useFloor;
